<template>
  <v-list-tile
    :key="deck.index"
    ripple>

    <v-list-tile-content>
      <v-list-tile-title>{{ deck.title }}</v-list-tile-title>
    </v-list-tile-content>

    <v-list-tile-action v-if="isAdmin">
      <v-btn icon ripple>
        <v-icon color="grey lighten-1">edit</v-icon>
      </v-btn>
    </v-list-tile-action>

    <v-list-tile-action v-if="isAdmin">
      <v-btn icon ripple>
        <v-icon color="grey lighten-1">delete</v-icon>
      </v-btn>
    </v-list-tile-action>
  </v-list-tile>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'DeckListItem',

  props: {
    deck: {
      required: true,
      type: Object
    }
  },

  computed: {
    ...mapGetters('auth', ['isAdmin'])
  },

  methods: {
    ...mapActions(['toggleModal', 'setSelectedItem'])
  }
}
</script>
